import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface ErrorDisplayProps {
  title?: string;
  message: string;
  fullScreen?: boolean;
  onRetry?: () => void;
}

export function ErrorDisplay({ 
  title = "Error loading database", 
  message, 
  fullScreen = true,
  onRetry 
}: ErrorDisplayProps) {
  const containerClass = fullScreen
    ? "h-screen w-screen flex items-center justify-center bg-background p-4"
    : "flex items-center justify-center p-8";

  return (
    <div className={containerClass}>
      <div className="max-w-md w-full flex flex-col items-center gap-6 p-6 rounded-lg border border-destructive/50 bg-destructive/5">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-destructive/10">
          <ExclamationTriangleIcon className="w-8 h-8 text-destructive" />
        </div>
        
        <div className="flex flex-col items-center gap-2 text-center">
          <h2 className="text-lg font-semibold text-foreground">{title}</h2>
          <p className="text-sm text-muted-foreground">{message}</p>
        </div>

        {onRetry && (
          <button
            onClick={onRetry}
            className="px-4 py-2 text-sm font-medium bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors shadow-sm"
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}

